import { VisuallyHidden } from '@react-aria/visually-hidden'
import { useModals } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { ChangeEventHandler, useRef } from 'react'
import { ConfirmFontModal } from 'components/ConfirmFontModal/ConfirmFontModal'
import { ButtonProps } from 'blaze-ui/Button/Types'

export const UploadFontButton = ({
  size = 'md',
  frontIcon,
  variant = 'ghost',
  label = 'Upload',
}: Pick<ButtonProps, 'size' | 'frontIcon' | 'variant'> & { label?: string }) => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const { openModal } = useModals()

  const handleChange: ChangeEventHandler<HTMLInputElement> = async (event) => {
    event.preventDefault()

    const files = Array.from(event.target.files || [])

    if (files.length > 0) {
      openModal(ConfirmFontModal, { files, openFontsModalOnUpload: false })
    }
  }

  return (
    <>
      <VisuallyHidden>
        <input type="file" onChange={handleChange} ref={fileInputRef} accept=".otf, .ttf, .woff" multiple />
      </VisuallyHidden>
      <Button
        variant={variant}
        size={size}
        frontIcon={frontIcon}
        onPress={() => {
          fileInputRef.current?.click()
        }}
      >
        {label}
      </Button>
    </>
  )
}
